import { RATING_COLOR } from '../ratingColors'

/** What the timeline's strokes and rings mean, said once beneath it. */
export function LabLegend() {
  return (
    <ul aria-label="Legend" className="flex flex-wrap gap-x-6 gap-y-2 font-mono text-xs uppercase tracking-widest text-muted">
      <li className="flex items-center gap-2">
        <svg aria-hidden width={24} height={8} className="shrink-0">
          <line x1={1} x2={23} y1={4} y2={4} stroke="var(--color-accent)" strokeWidth={2.25} strokeLinecap="round" />
        </svg>
        Your sliders
      </li>
      <li className="flex items-center gap-2">
        <svg aria-hidden width={24} height={8} className="shrink-0">
          <line x1={1} x2={23} y1={4} y2={4} stroke="var(--color-muted)" strokeWidth={1.25} strokeDasharray="4 5" strokeLinecap="round" />
        </svg>
        Saved settings
      </li>
      <li className="flex items-center gap-2">
        <svg aria-hidden width={12} height={12} className="shrink-0">
          <circle cx={6} cy={6} r={4.5} fill="var(--color-page-bg)" stroke={RATING_COLOR[3]} strokeWidth={1.5} />
        </svg>
        Assumed Good
      </li>
    </ul>
  )
}
